// Packages
import Big from 'big.js'

const store = {
  batchDate: null,
  client: {},
  clientReserve: '',
  clients: [],
  debtor: {},
  debtors: [],
  debtorNotFound: {
    id: null,
    name: 'debtor not found',
    doing_business_as: [ ],
    debtor_selected_name: 'debtor not found',
  },
  invoice: null,
  invoices: {
    invoices: [],
    pages: 0,
    sort: null,
    sum: new Big(0),
    total: 0,
  },
  mobile: {
    isMobile: false,
  },
  queue: {
    create: [],
    delete: [],
    update: {},
  },
  sentryTransactions: {
    'invoiceSubmission': null,
    'timeBetweenNewInvoiceAndSubmit': null,
    'timeBetweenUploadDocumentAndDisplay': null,
  },
  temp: {
    alert: {
      message: null,
      show: {
        next: true,
        previous: true,
      },
      visible: false,
    },
    clientWithoutBankModal: false,
    notifyReason: null,
    possibleDuplicates: [],
    recentCreditChecks: [],
    unknownDebtor: '',
  },
  universalSearchResults: {
    invoices: [],
    sum: null,
    total: null,
  },
  user: {},
}

export default store
